import { Axios } from "@/plugins";

export default {
  // scheduleId = scheduleName
  // userId = email
  // projectId = projectName+email
  invite: (payload) => {
    const { projectId, scheduleId, userId } = payload;
    return Axios.post(
      `/projects/${projectId}/schedules/${scheduleId}/users/${userId}`
    );
  },
};
